module.exports = __webpack_public_path__ + "static/28gde-bf58745c769be209ed7b1a4e1591c8a7.gif";